<template>
  <form id="resultForm" @submit="onSubmit">
    <TabPanel>
      <!-- 報告書発行日  -->
      <app-input-status
        label="報告書発行日"
        :message="submissionDateError"
        :validationError="submissionDateError ? true : false"
        :success="submissionDate && !submissionDateError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('submission_date')"
      />
      <app-date-input
        placeholder="発行日"
        v-model="submissionDate"
        name="submissionDate"
        color="blue"
      />
      <!-- 報告書発行日  -->
    </TabPanel>
    <TabPanel>
      <!-- 概要 -->
      <app-input-status
        label="概要"
        :message="overviewError"
        :validationError="overviewError ? true : false"
        :success="overview && !overviewError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('overview')"
      />
      <AppTiptap v-model="overview" name="overview" />
      <!-- 概要 -->
    </TabPanel>
    <TabPanel>
      <!-- 備考［任意］ -->
      <app-input-status
        label="備考［任意］"
        :message="remarksError"
        :validationError="remarksError ? true : false"
        :success="remarks && !remarksError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('remarks')"
      />

      <app-text-area
        id="remarks"
        v-model="remarks"
        color="blue"
        rows="15"
        name="remarks"
      ></app-text-area>
    </TabPanel>
    <TabPanel>
      <!-- 資料添付 -->
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('files')"
      />
      <AppImageUploader @changed="handleImages" type="result" />
    </TabPanel>
  </form>
</template>

<script>
import { TabPanel } from '@headlessui/vue'
import { onMounted } from 'vue'
import { useResultForm } from '@/services/politicalAction/useResultForm'
import AppSentBackItem from '@/components/ui/AppSentBackItem'
import AppDateInput from '@/components/ui/AppDateInput'
import AppInputStatus from '@/components/ui/AppInputStatus'
import AppTextArea from '@/components/ui/AppTextArea'
import AppImageUploader from '@/components/ui/AppImageUploader.vue'
import AppTiptap from '@/components/ui/AppTiptap'
import { useImgUploader } from '@/services/useImgUploader'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'

export default {
  name: 'ResultForm',

  components: {
    TabPanel,
    AppDateInput,
    AppInputStatus,
    AppTiptap,
    AppTextArea,
    AppSentBackItem,
    AppImageUploader,
  },

  setup() {
    const { imgUploader } = useImgUploader()
    const { currentPoliticalAction } = usePoliticalActions()

    onMounted(() => {
      let images = []

      if (
        currentPoliticalAction.report.images.length == 1 &&
        currentPoliticalAction.report.images[0].normalImage == null
      ) {
        images = []
      } else {
        for (let i = 0; i < currentPoliticalAction.report.images.length; i++) {
          currentPoliticalAction.report.images[i].blackImage != null
            ? images.push(currentPoliticalAction.report.images[i].blackImage)
            : images.push(currentPoliticalAction.report.images[i].normalImage)
        }
      }
      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images
    })
    return {
      ...useResultForm(),
    }
  },
}
</script>
<style lang="scss"></style>
